export const RPMBilling = (function() {
	'use strict';

	let $group;

	function init() {
		$group = $('.modal--billings');
		if($group.length > 0) {
			events();
		}
	}

	function events() {

		$group.each(function(idx){
			let $this = $(this);
			let $prev = $group[idx-1] ? '#' + $($group[idx-1]).attr('id') : '';
			let $next = $group[idx+1] ? '#' + $($group[idx+1]).attr('id') : '';

			$.ajax({
				method: 'GET',
				url: RPMConstants.themeDir + '/assets/svg/arrow.svg',
				dataType: 'html',
			}).done(function (result) {
				$('.arrow').html(result);
			}).fail(function (error) {
				console.log(error);
			});

			$this.append(`
				<div class="modal__nav">
					<a href="`+ $prev + `" class="modal__nav-prev ` + ( idx < 1 ? 'inactive' : '') + `"><span class="arrow"></span></a>
					<a href="`+ $next + `" class="modal__nav-next ` + ( $next ? '' : 'inactive') + `"><span class="arrow"></span></a>
				</div>
			`);
		});
	}

	return {
		init: init
	};

})();
